import { entityPostTypeIconRenderer } from 'static/Icons';

const PostTypeIcon = (props) => {
  const { value } = props;

  return entityPostTypeIconRenderer(value);
};

export default PostTypeIcon;
